/** Belge arşivi ekranının metinleri (Türkçe; CRM tek dilli). */
export const BELGELER = {
  baslik: 'Belge arşivi',
  aciklama: 'CRM\'de üretilen ve yüklenen bütün belgeler. İstediğin zaman yeniden indirebilir, siparişe bağlayabilirsin.',
  ara: 'Ara',
  araYer: 'Dosya adı, sipariş kodu, web sipariş numarası ya da müşteri',
  tur: 'Tür',
  turHepsi: 'Bütün türler',
  baglanti: 'Sipariş bağlantısı',
  baglantiHepsi: 'Hepsi',
  baglantiEvet: 'Siparişe bağlı',
  baglantiHayir: 'Siparişe bağlı değil',
  durum: 'Dosya durumu',
  durumHepsi: 'Hepsi',
  durumHazir: 'İndirilebilir',
  durumImha: 'İmha edilmiş',
  sutunlar: { dosya: 'Dosya', tur: 'Tür', siparis: 'Sipariş', musteri: 'Müşteri', boyut: 'Boyut', tarih: 'Üretildi', durum: 'Durum', islem: 'İşlem' },
  siparisYok: 'Bağlı değil',
  hazir: 'İndirilebilir',
  imhaEdildi: (tarih: string) => `İmha edildi, ${tarih}`,
  silinecek: (tarih: string) => `${tarih} tarihinde silinecek`,
  saklanir: 'Siparişe bağlı, en fazla 1 yıl saklanır',
  indir: 'İndir',
  indiriliyor: 'İndiriliyor',
  indirilemez: 'Dosya imha edildi, yeniden indirilemez',
  bagla: 'Siparişe bağla',
  baglaBaslik: 'Siparişe bağla',
  crmSiparis: 'CRM siparişi (kod)',
  webSiparis: 'Web siparişi (MBD-...)',
  siparisNo: 'Sipariş numarası',
  baglaOnayla: 'Bağla',
  vazgec: 'Vazgeç',
  baglandi: (dosya: string, siparis: string) => `${dosya} belgesi ${siparis} siparişine bağlandı.`,
  baglaNot: 'Siparişe bağlanan belge 15 gün sonra silinmez; bağlandığı günden 1 yıl sonra silinir. Web siparişine bağlanan belge müşteriye otomatik açılmaz.',
  bos: 'Bu süzgeçle eşleşen belge yok.',
  yukleniyor: 'Belgeler yükleniyor',
  hata: 'Belge listesi alınamadı.',
  yeniden: 'Yeniden dene',
  indirmeHatasi: 'Belge indirilemedi.',
  onceki: 'Önceki',
  sonraki: 'Sonraki',
  sayfa: (sayfa: number, toplam: number, adet: number) => `Sayfa ${sayfa} / ${toplam}, ${adet} belge`,
  turler: {
    VIZE_OTEL_VOUCHER: 'Vize otel rezervasyonu',
    VIZE_UCAK_BILETI: 'Vize uçak bileti',
    TUR_PDF_KAYNAK: 'Tur PDF kaynağı',
    VOUCHER: 'Voucher',
    SUPPLIER_CONFIRMATION: 'Tedarikçi onayı',
    PAYMENT_EVIDENCE: 'Ödeme kanıtı',
    CONTRACT: 'Sözleşme',
    OTHER: 'Diğer',
  } as Readonly<Record<string, string>>,
  duzenlenmis: (surum: number | null) => (surum ? `Düzenlenmiş PDF, sürüm ${surum}` : 'Düzenlenmiş PDF'),
} as const;
